// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q3h50","questions":"styles_questions__2krOq","footer":"styles_footer__YDGJQ"};